import { URLS } from "@/data/constants";
import { Button } from "@/components/design-system/Button/Button";
import { trackCalendlyClick } from "@/utils/analytics";
import React from "react";
import { IconCheckCircle } from "@/components/design-system/basic-icons/IconCheckCircle";

type CheckItem = {
  readonly text: string;
};

const checkItems: readonly CheckItem[] = [
  {
    text: "See how Bravo discovers held-away assets through natural participant conversations",
  },
  {
    text: "Watch the Advisor Intelligence Brief populate in real time from a live conversation",
  },
  {
    text: "Understand how Bravo maps to your specific employer relationships and advisor workflow",
  },
  {
    text: "Explore how quickly Bravo can go live inside your existing employer portal",
  },
] as const;

export const WealthGetStartedSection: React.FC = () => {
  const handleCalendlyClick = () => {
    trackCalendlyClick("wm_get_started");
    window.open(URLS.CALENDLY, "_blank");
  };

  return (
    <section className="bg-primary-50 w-full overflow-hidden">
      <div className="mx-auto max-w-360 px-5 py-16 md:px-8 md:py-24 lg:px-16">
        <div className="flex flex-col gap-6 md:grid md:grid-cols-2 md:gap-x-12 md:gap-y-6">
          <p className="caption-bold text-black uppercase md:col-start-1 md:row-start-1 md:text-right">
            Get Started
          </p>

          <div className="md:col-start-1 md:row-start-2 md:flex md:justify-end">
            <div className="flex w-full flex-col gap-4 md:max-w-114 md:gap-6">
              <h2 className="headline-d-extrabold md:headline-c-extrabold text-black md:text-right">
                See how Bravo activates your
                <span className="text-primary-500"> AUM growth.</span>
              </h2>
              <p className="body-a-regular md:subtitle-b-regular text-black md:text-right">
                Book a 30-minute demo to see Bravo in action. We'll show you how
                Bravo surfaces participant assets and routes them to your
                advisors.
              </p>
              <Button
                variant="solid"
                size="lg"
                onClick={handleCalendlyClick}
                className="hover:bg-primary-700 h-10 w-full px-4 text-base font-normal transition md:w-auto md:self-end lg:h-12 lg:px-6 lg:text-lg"
              >
                Book a demo
              </Button>
            </div>
          </div>

          <div className="md:col-start-2 md:row-start-2 md:flex md:items-start">
            <div className="flex w-full flex-col gap-6 md:max-w-114">
              {checkItems.map((item) => (
                <div key={item.text} className="flex items-start gap-3">
                  <IconCheckCircle
                    className="mt-0.5 h-6 w-6 shrink-0"
                    fillColor="var(--color-primary-50)"
                    strokeColor="var(--color-primary-500)"
                  />
                  <span className="body-b-regular text-black">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
